import {useState, useEffect, useCallback} from 'react';

const useWindowMatchMedia = (breakpoint) => {
  const handleMatch = useCallback(() => {
    const keyPoint = window.matchMedia(`(min-width: ${breakpoint})`)
    return keyPoint.matches;
  }, [breakpoint]);
  const [isMatch, setIsMatch] = useState(handleMatch());


  useEffect(() => {
    const handleResizeEvent = () => {
      setIsMatch(handleMatch());
    }
    window.addEventListener('resize', handleResizeEvent);


    return () => {
      window.removeEventListener('resize', handleResizeEvent);
    }
  }, [breakpoint, handleMatch]);

  return isMatch;
}

export default useWindowMatchMedia;
